import React from 'react';
import './SkeletonTable.css';

const SkeletonTable = ({ 
  overlay,
  rowCount = 8,
  filterCount = 4,
}) => {
  return (
    <div className="skeleton-page-wrapper">
      <div className="skeleton-page skeleton-loading">
        <div className="skeleton-filters">
          {Array.from({ length: filterCount }).map((_, i) => (
            <div key={i} className="skeleton-bone skeleton-filter-pill" />
          ))}
          <div className="skeleton-bone skeleton-search" />
        </div>
        <div className="skeleton-group">
          <div className="skeleton-thead">
            <div className="skeleton-bone skel-col-1" />
            <div className="skeleton-bone skel-col-2" />
            <div className="skeleton-bone skel-col-3" />
            <div className="skeleton-bone skel-col-4" />
            <div className="skeleton-bone skel-col-5" />
            <div className="skeleton-bone skel-col-6" />
          </div>
          {Array.from({ length: rowCount }).map((_, i) => (
            <div key={i} className="skeleton-data-row">
              <div className="skeleton-bone skel-col-1" />
              <div className="skel-main-wrap">
                <div className="skel-main-top">
                  <div className="skeleton-bone skel-id" />
                  <div className="skeleton-bone skel-title" />
                </div>
                <div className="skeleton-bone skel-subtitle" />
              </div>
              <div className="skeleton-bone skel-col-3" />
              <div className="skeleton-bone skel-col-4" />
              <div className="skeleton-bone skel-col-5" />
              <div className="skeleton-bone skel-col-6" />
            </div>
          ))}
        </div>
        {overlay && (
          <div className="skeleton-sync-overlay">
            {overlay}
          </div>
        )}
      </div>
    </div>
  );
};

export default SkeletonTable;
